import {
  FETCH_CSR_AGENT,
  FETCH_CSR_AGENT_END,
  FETCH_CSR_AGENT_ERROR,
  FETCH_CSR_AGENT_REPORT,
  FETCH_CSR_AGENT_REPORT_END,
  FETCH_CSR_AGENT_REPORT_ERROR,
  FETCH_CSR_AGENT_REPORT_START,
  FETCH_CSR_AGENT_START,
  REMOVE_CSR_AGENT,
  REMOVE_CSR_AGENT_REPORT,
  SET_TARGET_AGENT,
  UNSET_TARGET_AGENT,
} from './types';
import { messages } from '../../util/constants';
import { fetchCSRAgent, fetchCSRAgentReport } from '../../util/axiosHelper';

export const fetchAgents = criteria => async dispatch => {
  dispatch({
    type: FETCH_CSR_AGENT_START,
  });
  try {
    const res = await fetchCSRAgent(criteria);
    const { Agents } = res.data;

    if (Agents.length) {
      dispatch({
        type: FETCH_CSR_AGENT,
        payload: Agents,
      });
    } else {
      dispatch({
        type: FETCH_CSR_AGENT_ERROR,
        payload: messages.noAgentsMessage,
      });
    }
  } catch (e) {
    dispatch({
      type: FETCH_CSR_AGENT_ERROR,
      payload: e.message,
    });
  }
  dispatch({
    type: FETCH_CSR_AGENT_END,
  });
};

export const fetchAgentReport = (agentId, fromDate, toDate) => async dispatch => {
  dispatch({
    type: FETCH_CSR_AGENT_REPORT_START,
  });

  try {
    const res = await fetchCSRAgentReport({ agentId, fromDate, toDate });
    const { AgentReports } = res.data;

    dispatch({
      type: FETCH_CSR_AGENT_REPORT,
      payload: AgentReports,
    });
  } catch (e) {
    dispatch({
      type: UNSET_TARGET_AGENT,
    });

    dispatch({
      type: FETCH_CSR_AGENT_REPORT_ERROR,
      payload: e.message,
    });
  }

  dispatch({
    type: FETCH_CSR_AGENT_REPORT_END,
  });
};

export const removeAgentReport = () => dispatch => {
  dispatch({
    type: REMOVE_CSR_AGENT_REPORT,
  });
};

export const setTargetAgent = (agents, target) => dispatch => {
  return dispatch({
    type: SET_TARGET_AGENT,
    payload: {
      chosenAgent: agents[target],
      didPickAgent: true,
    },
  });
};

export const unsetTargetAgent = () => dispatch => {
  dispatch({
    type: REMOVE_CSR_AGENT_REPORT,
  });

  dispatch({
    type: UNSET_TARGET_AGENT,
  });
};

export const removeAgent = () => dispatch => {
  dispatch({
    type: UNSET_TARGET_AGENT,
  });

  dispatch({
    type: REMOVE_CSR_AGENT_REPORT,
  });

  return dispatch({
    type: REMOVE_CSR_AGENT,
  });
};
